import React, { useRef } from "react";
import { CircleHelp, Frown, Loader } from "lucide-react";
import Spacing from "../Spacing";
import { getPractice, usPhoneFormat } from "../../helpers";
import { Link } from "react-router-dom";
import { Drawer } from 'vaul';

export default function OtpConfirmationModal(
  { 
    actionType=()=>{}, 
    openModal=false, 
    setOpenModal=()=>{},
    enableOtpConfirmationLoader = false,
    sendFrom="",
    previousScrollPosition=0,
  }
) {
  const dropdownRef = useRef(null);
  let phoneNumber = getPractice("user_phone");
  let practiceEmail = getPractice("practice_email");

  const handleDrawerClose = () => {
    setOpenModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">OTP Confirmation</Drawer.Title>
            <Drawer.Description className="sr-only">OTP confirmation modal for send email</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                {sendFrom === "otp" ? (
                  <div className="docpro_deleteboxbox modal_height_100">
                    <div>
                      <div className="docpro_deleteboxbox">
                        {phoneNumber ? (
                          <div className="docpro_iconbox_icon docpro_orange_color">
                            <CircleHelp width={85} height={85} />
                          </div>
                        ) : (
                          <div className="docpro_iconbox_icon docpro_red_color">
                            <Frown width={85} height={85} />
                          </div>
                        )}
                        <Spacing lg="20" sm="20" />
                        <div className="docpro_iconbox_right">
                          {phoneNumber ? (
                            <>
                              <h3 className="docpro_fs_20 docpro_mb_0">Are you Sure?</h3>
                              <Spacing lg="15" sm="15" />
                              <p className="docpro_mb_0 docpro_fs_16">
                                You want to set OTP on your <span className="docpro_green_color docpro_fw_700">{phoneNumber && (usPhoneFormat(phoneNumber))}</span> number?
                              </p>
                            </>
                          ) : (
                            <p className="docpro_mb_0 docpro_fs_16">
                              Your profile doesn't have a contact number. Please update it to receive your 2-step verification code.
                            </p>
                          )}
                          <Spacing lg="32" sm="32" />
                        </div>
                      </div>
                    </div>
                    <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                      <button
                        className="docpro_bordered_btn docpro_fw_600 size_lg"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleDrawerClose();
                        }}
                      >
                        Cancel
                      </button>
                      {phoneNumber && 
                        <button
                          className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg docpro_btn_green`}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            actionType();
                          }}
                          disabled = {enableOtpConfirmationLoader ? true : false}
                        >
                          <span>Yes, Confirm</span>
                          {enableOtpConfirmationLoader && (
                            <span className="docpro_loading">
                              <Loader width={20} height={20} />
                            </span>
                          )}
                        </button>
                      }
                    </div>
                  </div>
                ) : (
                  <div className="docpro_deleteboxbox modal_height_100">
                    <div>
                      <div className="docpro_deleteboxbox">
                        {practiceEmail ? (
                          <div className="docpro_iconbox_icon docpro_orange_color">
                            <CircleHelp width={85} height={85} />
                          </div>
                        ) : (
                          <div className="docpro_iconbox_icon docpro_red_color">
                            <Frown width={85} height={85} />
                          </div>
                        )}
                        <Spacing lg="20" sm="20" />
                        <div className="docpro_iconbox_right">
                          {practiceEmail ? (
                            <>
                              <h3 className="docpro_fs_20 docpro_mb_0">Are you Sure?</h3>
                              <Spacing lg="15" sm="15" />
                              <p className="docpro_mb_0 docpro_fs_16">
                                You want to send mail on "<span className="docpro_green_color docpro_fw_700">{practiceEmail ? practiceEmail : ""}</span>" email?
                              </p>
                            </>
                          ) : (
                            <p className="docpro_mb_0 docpro_fs_16">
                              Your selected practice doesn't have an email address. Please update it from <Link to="/admin/settings" className="docpro_accent_color">settings</Link> to receive report.
                            </p>
                          )}
                          <Spacing lg="32" sm="32" />
                        </div>
                      </div>
                    </div>
                    <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                      <button
                        className="docpro_bordered_btn docpro_fw_600 size_lg"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleDrawerClose();
                        }}
                      >
                        Cancel
                      </button>
                      {practiceEmail ? 
                        <button
                          className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg docpro_btn_green`}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            actionType();
                          }}
                          disabled = {enableOtpConfirmationLoader ? true : false}
                        >
                          <span>Yes, Confirm</span>
                          {enableOtpConfirmationLoader && (
                            <span className="docpro_loading">
                              <Loader width={20} height={20} />
                            </span>
                          )}
                        </button>
                      :
                        ""
                      }
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
